import TimeDisplay from '../TimeDisplay';
import type { ExecutionLog } from '../../types/strategy';
import type { RealizedTrade } from '../../services/historyApi';

interface ExecutionLogTableProps {
  logs: ExecutionLog[];
  marketLabel?: string;
}

interface RealizedTradeTableProps {
  trades: RealizedTrade[];
}

function formatQty(value: number | null) {
  if (value === null) return '-';
  return value.toFixed(8).replace(/\.?0+$/, '');
}

function formatMoney(value: number | null) {
  if (value === null || value === 0) return '-';
  return `$${Math.abs(value).toFixed(2)}`;
}

export function ExecutionLogTable({ logs, marketLabel = 'US' }: ExecutionLogTableProps) {
  return (
    <div className="history-table-wrap">
      <table className="history-table">
        <thead>
          <tr>
            <th>시장</th>
            <th>시간</th>
            <th>종목</th>
            <th>액션</th>
            <th>결과</th>
            <th>수량</th>
            <th>가격</th>
            <th>사유</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log) => (
            <tr key={log.id}>
              <td>{marketLabel}</td>
              <td><TimeDisplay utcTime={log.executed_at} /></td>
              <td>{log.symbol}</td>
              <td>{log.action}</td>
              <td>{log.executed ? '실행' : '미실행'}</td>
              <td>{formatQty(log.quantity)}</td>
              <td>{log.price ? `$${log.price.toFixed(2)}` : '-'}</td>
              <td className="history-reason">{log.reason}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function RealizedTradeTable({ trades }: RealizedTradeTableProps) {
  return (
    <div className="history-table-wrap">
      <table className="history-table">
        <thead>
          <tr>
            <th>시간</th>
            <th>종목</th>
            <th>유형</th>
            <th>수량</th>
            <th>수익률</th>
            <th>수익 금액</th>
          </tr>
        </thead>
        <tbody>
          {trades.map((trade) => (
            <tr key={trade.id}>
              <td><TimeDisplay utcTime={trade.executed_at} /></td>
              <td>{trade.symbol}</td>
              <td>{trade.trade_type}</td>
              <td>{formatQty(trade.quantity)}</td>
              <td>{trade.profit_percent.toFixed(2)}%</td>
              <td>{formatMoney(trade.profit_amount)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
